import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetJObofferCall,
  SetJObofferCallAction,
  SetActiveTabs,
  SetJObofferDITCallAction,
  setTherossSalaryCreateActions,
  setTherossSalaryActions,
  setClientBranchActions, ///----Client----Branch
  setZoneActions,
  getRoleListActions, ////---role---
  setTheGrossSalarayAmount, ///---gross---salary----amount--hold
  setClientBranchesRetrieveActions,
  setRoleRetrieveActions,
  SetIdVeriications,
  setPreviousDataFetchActions,
  setClientBranchSearchAction,
  settheJobinfoBranchEmployeeProfile,
  setthejobinformationroleID,
  SettheBracnhId,
  resetOrganizationRmFilterlist,
  SetJObofferPreviewCallAction,
} from "../../../Redux/Slice";
import { NumericFormat } from "react-number-format";
import useDebouncedEffect from "use-debounced-effect";
import Select from "react-select";
import { set, unescape } from "lodash";
import { da, is } from "date-fns/locale";
import { toast } from "react-toastify";
import axios from "axios";
import { clientBranRetrieve } from "../../../text/apidata";
import SalaryOfferPreviewPopup from "./SalaryOfferPreviewPopup";
import { use } from "react";

// division_level is a list of strings; older records may still hold a single string
const toDivisionLevelList = (value) =>
  Array.isArray(value) ? value : value ? [value] : [];

const Joboffer = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const organization = useSelector(
    (state) => state.NumberCounts.selectedOnoardClient,
  );
  const isAthena =
    organization?.organization?.id == "28e108e0-a644-4365-89df-317867f00f22";
  // only payroll (0), regional manager (1) and super admin (3) can edit division level
  const canEditDivisionLevel = ["0", "1", "3"].includes(
    String(state.ClientBranchIDs.SUBROLE),
  );

  const [branchoptions, setbranchoptions] = useState(); //----
  const [roleoptionsList, setROleoptionsList] = useState(); ///--role---
  const [addbasic, setthebasic] = useState(
    organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ? true
      : false,
  ); ///---to add basic salary field for 11a8ab83-0669-4098-a453-ddb2a2e0c39e organization

  var CheckBoxfile = addbasic;
  var IDS = "";
  ///--Searchc----
  const initialStateSearch = {
    BranchSearch: "",
    roleSearch: "",
    organizationRm_search: "",
  };
  var timeid;

  const [ErrorInde, setErrInde] = useState(0);
  useEffect(() => {
    timeid = state.BasicFormCreated.BasciFormCreate;
  }, [state.BasicFormCreated.BasciFormCreate]);

  const [SearchedVal, setSearched] = useState(initialStateSearch);
  var roleIDs = ""; ///---role----id----
  const initialState = {
    job_title: "",
    department:
      state.BranchRetrieve.BranchesRetrieve.wbs_element != "" &&
        state.BranchRetrieve.BranchesRetrieve.wbs_element != null
        ? state.BranchRetrieve.BranchesRetrieve.wbs_element
        : "",
    designation: state.NumberCounts.RoleOjects.value,
    //  gross_salary:  state.roleRetrieve.RoleRetrieve.salary != "" &&  state.roleRetrieve.RoleRetrieve.salary != null ?  state.roleRetrieve.RoleRetrieve.salary : "",
    gross_salary: Number(),
    //  timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
    timeline_id: timeid,
    // designation_id: state.NumberCounts.RoleOjects.value,
    designation_id: state?.NumberCounts?.RoleOjects?.value,
    client_id: state.NumberCounts.BranchObjectJobInfoFieldAgent?.value,
    // from_salary,to_salary

    other_allowances_salary: Number(),
    net_salary: Number(),
    hra_salary: Number(),
    employee_PF: Number(),
    employee_ESI: Number(),
    airtime_allowance: Number(),
    basic_salary: Number(),
    project_code: state?.BranchRetrieve?.BranchesRetrieve?.project_code,
    program_code: state?.BranchRetrieve?.BranchesRetrieve?.program_code,
    product_code: state?.BranchRetrieve?.BranchesRetrieve?.product_code,
    division_level: isAthena
      ? []
      : state?.BranchRetrieve?.BranchesRetrieve?.division_level,
    client_code: state?.BranchRetrieve?.BranchesRetrieve?.client_code,
    division_code: state?.BranchRetrieve?.BranchesRetrieve?.division_code,
    division_name: state?.BranchRetrieve?.BranchesRetrieve?.division_name,
    joining_bonus: "",
    entertainment_reimbursement: "",
    Stipend: "",
    advance_bonus: "",
    medical_insurance: "",
    accident_insurance: "",
    premium_insurance: "",
    variable_salary: "",
    da_salary: "",
    ca_salary: "",
    swa_salary: "",
    stationary_bonus: "",
    // professional_tax: "",
    bonus: "",
    mobile_expenses: "",
    retention_bonus: "",
    conveyance: "",
    is_gratuity: false,
    // lwf_employee: "",
    rm_id: "",
    pm_id: "",
    vh_id: "",
  };

  const [data, setData] = useState(initialState);

  useEffect(() => {
    if (state.BranchRetrieve.BranchesRetrieve != "") {
      setData({
        ...data,
        // Athena picks division levels from a dropdown, so don't auto-fill
        ...(!isAthena && {
          division_level:
            state?.BranchRetrieve?.BranchesRetrieve?.division_level,
        }),
        product_code: state?.BranchRetrieve?.BranchesRetrieve?.product_code,
        project_code: state?.BranchRetrieve?.BranchesRetrieve?.project_code,
        program_code: state?.BranchRetrieve?.BranchesRetrieve?.program_code,
        client_code: state?.BranchRetrieve?.BranchesRetrieve?.client_code,
        division_code: state?.BranchRetrieve?.BranchesRetrieve?.division_code,
        division_name: state?.BranchRetrieve?.BranchesRetrieve?.division_name,
      });
    }
  }, [state.BranchRetrieve.BranchesRetrieve]);

  const [jobinfo, setjobinfo] = useState({
    job_status: "0",
    end_date: "",
  });
  console.log(
    state.BranchRetrieve,
    "dkfjksjkdfksdkjsd",
    state.NumberCounts,
    data,
  );
  const [end_dateerr, setend_daterr] = useState("");
  const [jobtotitleErr, setTitelErr] = useState("");
  const [departmentErr, sedepartmentErr] = useState("");
  const [designationerr, setdesginationErr] = useState("");
  const [grossSalaryErr, setGrossError] = useState("");
  const [rmError, setRMError] = useState("");
  const [pmError, setPMError] = useState("");
  const [vhError, setVHError] = useState("");
  const [medicalInsuranceError, setMedicalInsuranceError] = useState("");
  const [accidentInsuranceError, setAccidentInsuranceError] = useState("");
  const [premiumInsuranceError, setPremiumInsuranceError] = useState("");

  const [variableSalaryError, setVariableError] = useState("");
  const [stationaryError, setStationaryError] = useState("");
  const [professionalError, setProfessionalError] = useState("");
  const [bonusError, setBonusError] = useState("");
  const [mobileExpensesError, setMobileExpensesError] = useState("");
  const [conveyanceError, setConveyanceError] = useState("");
  const [retentionBonusError, setRetentionBonusError] = useState("");
  const [lwfError, setLwfError] = useState("");
  const [caError, setCAError] = useState("");
  const [projectNatureError, setProjectNatureError] = useState("");
  const [billingAbilityError, setBillingAbilityError] = useState("");
  const [billingTypeError, setBillingTypeError] = useState("");
  const [divisionLevelError, setDivisionLevelError] = useState("");
  const [branchvalue, SteBranchValue] = useState();
  const [RoleValue, setRoleValue] = useState();
  const [siteObjectVal, setSiteObjectVal] = useState();
  const [siteIDs, setSiteIDS] = useState();
  const [retrievedid, setRetrveeId] = useState();
  console.log(data, "asdajsdn");
  //  const [Validation , setValidated] = useState(0)
  ////---Get--sub role--
  const UserData = useSelector((state) => state.users.UserData);
  const [SubRoleList, setSubRoleList] = useState();
  const [nameList4, setOptions4] = useState([]);
  const [SearchBranch, setSearchBranch] = useState();
  const [branchMantory, setbranchMantory] = useState("");
  const [basicErro, setBasicErr] = useState("");
  const [hraerr, setHraErr] = useState("");
  const [otherErr, setOtherErr] = useState("");
  const [pferr, setPFerr] = useState("");
  const [ESIErr, setESIerr] = useState("");
  const [AirTimeErr, setAirTimeAllo] = useState("");
  const [netslaraer, setNetSalarErr] = useState("");
  const [ZoneSearch, setZoneSearch] = useState("");
  const [Organization_RM_options, setOrganization_RM_options] = useState([]);

  const [organization_RM_Val, setOrganization_RM_Val] = useState({});
  const [organization_PM_Val, setOrganization_PM_Val] = useState({});
  const [organization_VH_Val, setOrganization_VH_Val] = useState({});

  const [rmOptionList, setRmOptionList] = useState([]);
  const [pmOptionList, setPmOptionList] = useState([]);
  const [vhOptionList, setVhOptionList] = useState([]);

  const [salaryPreviewPopup, setSalaryPreviewPopup] = useState(false);

  useEffect(() => {
    if (state.BranchRetrieve.BranchesRetrieve) {
      const rmList = state?.BranchRetrieve?.BranchesRetrieve?.rm_ids?.map(
        (element) => {
          return {
            value: element.id,
            label: element.first_name,
          };
        },
      );

      setRmOptionList(rmList);
      const pmList = state?.BranchRetrieve?.BranchesRetrieve?.pm_ids?.map(
        (element) => {
          return {
            value: element.id,
            label: element.first_name,
          };
        },
      );

      setPmOptionList(pmList);
      const vhList = state?.BranchRetrieve?.BranchesRetrieve?.vh_ids?.map(
        (element) => {
          return {
            value: element.id,
            label: element.first_name,
          };
        },
      );

      setVhOptionList(vhList);
    }
  }, [state.BranchRetrieve.BranchesRetrieve]);

  const initialDebouanceSearch = {
    Zonesearch: "",
    roleSearch: "",
    Clientsearch: "",
    organizationRm_search: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  // useEffect(() => {
  //   if (
  //     // state.FormsIDList.Job_offer_id == "" &&
  //     // state.NumberCounts.EmployeeRoleId != "" &&
  //     data.designation_id != ""&&
  //     state.FormsIDList.ActiveTabs == 10
  //   ) {
  //     const payload = {
  //       // EditID: state.NumberCounts.EmployeeRoleId,
  //       EditID:data.designation_id
  //     };
  //     ///   console.log(state.roleRetrieve.RoleRetrieve  ,"afsd");
  //     dispatch(setRoleRetrieveActions(payload));

  //   }
  // }, [
  //   // state.NumberCounts.EmployeeRoleId,
  //    state.FormsIDList.ActiveTabs == 10,
  //   data.designation_id]);

  useEffect(() => {
    if (
      organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
    ) {
      const payloads = {
        search: SearchedVal.organizationRm_search,
        page_size: "20",
        page: 1,
        org_ids: "11a8ab83-0669-4098-a453-ddb2a2e0c39e",
      };
      dispatch(resetOrganizationRmFilterlist(payloads));
    }
  }, [SearchedVal.organizationRm_search, organization?.organization]);
  useEffect(() => {
    if (
      state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records
    ) {
      let ObjectArrayFormager = [];
      state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.first_name + " " + element.last_name,
          });
        },
      );
      console.log(ObjectArrayFormager, "sJKASKasjKJAJSJKslkdlka");
      setOrganization_RM_options(ObjectArrayFormager);
    }
    console.log(state.organizationRm_filterlist_tocall, "dklalkklaskdkaksd");
  }, [
    state.organizationRm_filterlist_tocall.OrganizationRm_filterlist_records,
    SearchedVal.organizationRm_search,
    organization?.organization,
  ]);

  console.log(state, "Daskldklak");
  useEffect(() => {
    if (
      state.NumberCounts.branchId != undefined &&
      state.FormsIDList.Job_offer_id == "" &&
      state.FormsIDList.ActiveTabs == 10
    ) {
      const payload = {
        EditId: state.NumberCounts.branchId,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
    }
  }, [state.NumberCounts.branchId, state.FormsIDList.ActiveTabs]);

  ///---Athena: division level options come from the selected client---
  // fetched locally so the shared BranchRetrieve state is left untouched
  const [divisionLevelOptions, setDivisionLevelOptions] = useState([]);

  useEffect(() => {
    setDivisionLevelOptions([]);
    if (!isAthena || state.FormsIDList.ActiveTabs != 10 || !data.client_id) {
      return;
    }
    let ignore = false;
    axios({
      method: "get",
      url: clientBranRetrieve + data.client_id + "/",
      headers: {
        Authorization: "Bearer " + state.users.UserData.session.token,
      },
    })
      .then((response) => {
        if (!ignore) {
          setDivisionLevelOptions(
            toDivisionLevelList(response.data.data?.division_level).map(
              (level) => ({ value: level, label: level }),
            ),
          );
        }
      })
      .catch(() => {});
    return () => {
      ignore = true;
    };
  }, [data.client_id, state.FormsIDList.ActiveTabs, isAthena]);

  // console.log(state.BranchRetrieve.BranchesRetrieve.wbs_element, "BranchesRetrieve",       state.roleRetrieve.RoleRetrieve);

  // function calculateSalary() {
  //   const { wages, salary } = state.roleRetrieve.RoleRetrieve;

  //   if (wages === 1) {
  //     // Calculate weekly salary (assuming 4 weeks in a month)
  //     const weeklySalary = salary / 4;
  //     return weeklySalary;
  //   } else if (wages === 0) {
  //     // Calculate daily salary (assuming 20 working days in a month)
  //     const dailySalary = salary / 20;
  //     return dailySalary;
  //   } else {
  //     // Handle other cases or invalid values for wages
  //     return 0; // Default to 0 or handle error as needed
  //   }
  // }

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      data.job_title != "" &&
      data.job_title != undefined
    ) {
      const payload = {
        search: SearchBranch,
        page_size: "",
        page: 1,
        data: { state: "", region: "", zone: data.job_title },
      };
      dispatch(setClientBranchSearchAction(payload));
    }
  }, [data.job_title, state.FormsIDList.ActiveTabs, SearchBranch]);
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearchBranch(SearchDebounance.Clientsearch);
        setZoneSearch(SearchDebounance.Zonesearch);
        setSearched({
          ...SearchedVal,
          roleSearch: SearchDebounance.roleSearch,
          organizationRm_search: SearchDebounance.organizationRm_search,
        });
      }
    },
    500,
    [SearchDebounance],
  );

  const HandleInputBranch = (e) => {
    // setSearchBranch(e);
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, SearchBranch]);
  useEffect(() => {
    if (state.users.UserData.data != undefined) {
    }
    if (UserData.session) {
      // console.log(UserData.data.sub_role, "UserDsdsdasdata");
      if (UserData.data != undefined && UserData.data != null) {
        setSubRoleList(UserData.data.sub_role);
      }
    }
  }, [UserData]);

  ///---Retrieve----------------------------
  useEffect(() => {
    if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.ActiveTabs == 10
    ) {
      const payload = {
        Retieveid: state.FormsIDList.Job_offer_id,
      };

      dispatch(SetJObofferCall(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  ///---Search----Client--Branch---

  const handleInputRoleChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      roleSearch: Val,
    });
  };
  const handleInputChangeZone = (Val) => {
    // setZoneSearch(Val);
    setSearchDebounance({
      ...SearchDebounance,
      Zonesearch: Val,
    });
  };

  useEffect(() => {
    // console.log(state.ZonePart.Zone, "Branch");
    if (state.ZonePart.Zone != undefined) {
      let branchlist = [];
      state.ZonePart.Zone.forEach((element) => {
        branchlist.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setbranchoptions(branchlist);
    }
  }, [state.ZonePart.Zone, ZoneSearch]);

  ////---Role-----

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      data.client_id != null &&
      data.client_id != undefined &&
      data.client_id != "" &&
      data.client_id != "" &&
      data.client_id != undefined
    ) {
      const payload = {
        search: SearchedVal.roleSearch,
        page_size: 20,
        page: 1,
        mode: "",
        client: data.client_id,
        white_collar: false,
      };
      dispatch(getRoleListActions(payload));

      console.log(data.client_id, "qwiuioqweu data.client_id");
    }
  }, [
    state.FormsIDList.ActiveTabs == 10,
    data.client_id,
    SearchedVal.roleSearch,
  ]);

  ////-------Client---Barhnch---
  useEffect(() => {
    if (state.FormsIDList.ActiveTabs === 10) {
      const payload = {
        search: ZoneSearch,
        page_size: 20,
        page: 1,
        //  client:state.NumberCounts.BranchObjectJobInfoFieldAgent?.value,
        counts: 4,
      };
      dispatch(setZoneActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs == 10, ZoneSearch]);

  ////---Role------

  useEffect(() => {
    // console.log(state.rolelists.RoleList, "tole");
    if (state.rolelists.RoleList != undefined) {
      let branchlist = [];

      state.rolelists.RoleList.forEach((element) => {
        branchlist.push({
          value: element.id,
          label: element.role.toUpperCase(),
        });
      });
      setROleoptionsList(branchlist);
    }
  }, [
    state.rolelists.RoleList,
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
  ]);

  /////---Set------role---and---branch--valuews---based on---by clicking----branch---row , adn--clicking-the--role
  useEffect(() => {
    if (
      state.FormsIDList.Job_offer_id == "" &&
      // state.NumberCounts.EmployeeRoleId == "" &&
      state.NumberCounts.BranchObject != undefined &&
      state.NumberCounts.RoleOjects != undefined &&
      state.NumberCounts.Editable == 2
    ) {
      let IDs = [];
      SteBranchValue();
      setRoleValue(state.NumberCounts.RoleOjects);
      roleIDs = state.NumberCounts.RoleOjects.value; ///---role----id----

      //  console.log(state.NumberCounts.RoleOjects.value ,"asdasd");
      setData({
        ...data,
        designation_id: state.NumberCounts.RoleOjects.value,
      });
    }
    if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.JOBOfferCall.JobDATATS != undefined &&
      state.JOBOfferCall.JobDATATS.designation_id != undefined &&
      state.JOBOfferCall.JobDATATS.designation_id != null
      // &&
      // state.NumberCounts.EmployeeRoleId != ""
    ) {
      let descriptionFromRepose = [];
      descriptionFromRepose.push({
        value: state.JOBOfferCall.JobDATATS.designation_id.id,
        label: state.JOBOfferCall.JobDATATS.designation_id.role,
      });
      setData({
        ...data,
        designation_id: state.JOBOfferCall.JobDATATS.designation_id.id,
      });
      setdesginationErr("");

      setRoleValue(descriptionFromRepose); ////----if the count is 2 then , the flow path is kyc verifications,site
      ///---if the designation_id is represent then we can display it or else it have to be empty
    }

    if (state.FormsIDList.Job_offer_id == "") {
      setSiteObjectVal(state.NumberCounts.ZONEobjects);
      setData({
        ...data,
        job_title: state.NumberCounts.ZONEobjects.value,
      });
      setTitelErr("");
    } else if (
      state.FormsIDList.Job_offer_id != "" &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id
    ) {
      setData({
        ...data,
        job_title: siteIDs,
      });
      setTitelErr("");
    }
    console.log(state.FormsIDList.Job_offer_id, "sduapsod Job_offer_id");
  }, [
    state.NumberCounts.RoleOjects,
    state.NumberCounts.BranchObject,
    state.JOBOfferCall.JobDATATS,
    // state.JOBOfferCall.JobDATATS
  ]);

  /////----Changes-------branch----
  const handleBranchChange = (val) => {
    SteBranchValue(val);
    setData({
      ...data,
      job_title: val.value,
    });
    setSiteObjectVal(val);
    setSiteIDS(val.value);
    if (state.NumberCounts.Editable == 1) {
      setRoleValue({ value: "", label: "Select" });

      dispatch(
        settheJobinfoBranchEmployeeProfile({ value: "", label: "Select" }),
      );

      setData({
        ...data,
        client_id: "",
        designation_id: "",
        ...(isAthena && { division_level: [] }),
      });
      setDivisionLevelError("");
    }
  };

  const [value, setValue] = useState("");

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const parsedValue = parseFloat(inputValue);
    // Check if input exceeds 8 digits
    if (inputValue.length > 9) {
      setGrossError("*Indicative Salary cannot exceed 8 digits.");
      setErrInde(1);
      e.target.value = data.gross_salary; // Revert to previous valid value
      return;
    }

    // Check if input is less than or equal to 0
    if (parsedValue <= 0) {
      setGrossError("*Indicative Salary must be greater than 0.");
      setErrInde(1);
      e.target.value = "";
      return;
    }

    // Valid input
    setGrossError("");
    setErrInde(0);
    setData({
      ...data,
      gross_salary: inputValue,
    });
    HandleChanges(e);
  };

  const inputRef = useRef(null);
  const preventZoom = (event) => {
    console.log(event, "asdasdevent", event?.type == "wheel", "sadasdasd");

    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }

    if (event?.type == "wheel") {
      event.preventDefault();
    }

    if (["e", "E", "+", "-", "."].includes(event.key)) {
      event.preventDefault();
    }
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
    }

    // if (evt.ctrlKey || evt.metaKey) {
    //   evt.preventDefault();
    // }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener("wheel", preventZoom);
    }

    // Cleanup to remove the event listener when the component unmounts
    return () => {
      if (inputElement) {
        inputElement.removeEventListener("wheel", preventZoom);
      }
    };
  }, []);

  const HandleBranchChanges = (e) => {
    setDivisionLevelError("");
    if (e != null) {
      dispatch(
        settheJobinfoBranchEmployeeProfile({ value: e.value, label: e.label }),
      );
      setRoleValue({ value: "", label: "Select" });
      dispatch(setthejobinformationroleID(""));

      setData({
        ...data,
        client_id: e.value,
        designation_id: "",
        ...(isAthena && { division_level: [] }),
      });
    } else {
      dispatch(
        settheJobinfoBranchEmployeeProfile({ value: "", label: "Select" }),
      );
      setRoleValue({ value: "", label: "Select" });
      dispatch(setthejobinformationroleID(""));

      setData({
        ...data,
        client_id: "",
        designation_id: "",
        ...(isAthena && { division_level: [] }),
      });
    }
  };
  ///---Role-----
  const handleDesignationChange = (val) => {
    setRoleValue(val);
    setData({
      ...data,
      designation_id: val.value,
    });
    dispatch(setthejobinformationroleID(val.value));
    dispatch(SettheBracnhId(val.value));
  };
  const HandleChanges = (e) => {
    setData((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value.toUpperCase(),
      };
    });
    if (e.target.name == "gross_salary") {
      dispatch(setTheGrossSalarayAmount(e.target.value));
    }
  };
  console.log(state.JOBOfferCall, "jobkjk", data);
  useEffect(() => {
    if (
      state.JOBOfferCall.JobDATATS.id != undefined &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.FormsIDList.Job_offer_id != ""
    ) {
      console.log(state.JOBOfferCall.JobDATATS, "klsdkalksdkalsdklad");
      setData({
        ...data,
        job_title: siteIDs,
        department: state.JOBOfferCall.JobDATATS.department,
        designation: state.JOBOfferCall.JobDATATS.designation,
        gross_salary: state.JOBOfferCall.JobDATATS.gross_salary,
        designation_id:
          state.JOBOfferCall.JobDATATS.designation_id != undefined &&
            state.JOBOfferCall.JobDATATS.designation_id != null
            ? state.JOBOfferCall.JobDATATS.designation_id.id
            : "",
        client_id:
          state.JOBOfferCall.JobDATATS.client_id != undefined &&
            state.JOBOfferCall.JobDATATS.client_id != null
            ? state.JOBOfferCall.JobDATATS.client_id.id
            : state.NumberCounts.BranchObjectJobInfoFieldAgent != null &&
              state.NumberCounts.BranchObjectJobInfoFieldAgent != undefined &&
              state.NumberCounts.BranchObjectJobInfoFieldAgent != ""
              ? state.NumberCounts.BranchObjectJobInfoFieldAgent?.value
              : "",
        other_allowances_salary:
          state.JOBOfferCall.JobDATATS.other_allowances_salary,
        net_salary: state.JOBOfferCall.JobDATATS.net_salary,
        hra_salary: state.JOBOfferCall.JobDATATS.hra_salary,
        employee_PF: state.JOBOfferCall.JobDATATS.employee_PF,
        employee_ESI: state.JOBOfferCall.JobDATATS.employee_ESI,
        basic_salary: state.JOBOfferCall.JobDATATS.basic_salary,
        airtime_allowance: state.JOBOfferCall.JobDATATS.airtime_allowance,
        client_code: state.JOBOfferCall.JobDATATS.client_code,
        division_code: state.JOBOfferCall.JobDATATS.division_code,
        program_code: state.JOBOfferCall.JobDATATS.program_code,
        project_code: state.JOBOfferCall.JobDATATS.project_code,
        product_code: state.JOBOfferCall.JobDATATS.product_code,
        division_name: state.JOBOfferCall.JobDATATS.division_name,
        medical_insurance: state.JOBOfferCall.JobDATATS.medical_insurance,
        // Athena
        joining_bonus: state.JOBOfferCall.JobDATATS.joining_bonus,
        entertainment_reimbursement: state.JOBOfferCall.JobDATATS.entertainment_reimbursement,
        Stipend: state.JOBOfferCall.JobDATATS.Stipend,
        advance_bonus: state.JOBOfferCall.JobDATATS.advance_bonus,
        division_level: toDivisionLevelList(
          state.JOBOfferCall.JobDATATS.division_level,
        ),

        product_code: state.JOBOfferCall.JobDATATS.product_code,
        // end
        accident_insurance: state.JOBOfferCall.JobDATATS.accident_insurance,
        premium_insurance: state.JOBOfferCall.JobDATATS.premium_insurance,
        variable_salary: state.JOBOfferCall.JobDATATS.variable_salary,
        stationary_bonus: state.JOBOfferCall.JobDATATS.stationary_bonus || "",
        // professional_tax: state.JOBOfferCall.JobDATATS.professional_tax || "",
        bonus: state.JOBOfferCall.JobDATATS.bonus || 0,
        mobile_expenses: state.JOBOfferCall.JobDATATS.mobile_expenses || 0,
        conveyance: state.JOBOfferCall.JobDATATS.conveyance || 0,
        retention_bonus: state.JOBOfferCall.JobDATATS.retention_bonus || 0,
        is_gratuity: state.JOBOfferCall.JobDATATS.is_gratuity || false,
        // lwf_employee: state.JOBOfferCall.JobDATATS.lwf_employee || "",
        rm_id: state.JOBOfferCall.JobDATATS.rm_id?.id,
        pm_id: state.JOBOfferCall.JobDATATS.pm_id?.id,
        vh_id: state.JOBOfferCall.JobDATATS.vh_id?.id,
        swa_salary: state.JOBOfferCall.JobDATATS.swa_salary,
        da_salary: state.JOBOfferCall.JobDATATS.da_salary,
        ca_salary: state.JOBOfferCall.JobDATATS.ca_salary,
      });

      setjobinfo({
        ...jobinfo,
        job_status: state.JOBOfferCall.JobDATATS?.job_status,
        project_nature: state.JOBOfferCall.JobDATATS.project_nature,
        billabilty: state.JOBOfferCall.JobDATATS.billabilty,
        billing_type: state.JOBOfferCall.JobDATATS.billing_type,
        end_date: (() => {
          const endDate = state.JOBOfferCall.JobDATATS?.end_date;
          if (!endDate) return ""; // handle null or undefined
          const [day, month, year] = endDate.split("/"); // split DD/MM/YYYY
          return `${year}-${month}-${day}`; // convert to YYYY-MM-DD
        })(),
      });
      if (state.JOBOfferCall.JobDATATS.rm_id) {
        setOrganization_RM_Val({
          label:
            state.JOBOfferCall.JobDATATS.rm_id.first_name +
            " " +
            state.JOBOfferCall.JobDATATS.rm_id.last_name,
          value: state.JOBOfferCall.JobDATATS.rm_id.id,
        });
      }
      if (state.JOBOfferCall.JobDATATS.pm_id) {
        setOrganization_PM_Val({
          label:
            state.JOBOfferCall.JobDATATS.pm_id.first_name +
            " " +
            state.JOBOfferCall.JobDATATS.pm_id.last_name,
          value: state.JOBOfferCall.JobDATATS.pm_id.id,
        });
      }
      if (state.JOBOfferCall.JobDATATS.vh_id) {
        setOrganization_VH_Val({
          label:
            state.JOBOfferCall.JobDATATS.vh_id.first_name +
            " " +
            state.JOBOfferCall.JobDATATS.vh_id.last_name,
          value: state.JOBOfferCall.JobDATATS.vh_id.id,
        });
      }

      setthebasic(
        state.JOBOfferCall.JobDATATS.other_allowances_salary != "" ||
          state.JOBOfferCall.JobDATATS.net_salary != "" ||
          state.JOBOfferCall.JobDATATS.employee_PF != "" ||
          state.JOBOfferCall.JobDATATS.employee_ESI != "" ||
          state.JOBOfferCall.JobDATATS.basic_salary != "" ||
          state.JOBOfferCall.JobDATATS.airtime_allowance != "" ||
          organization?.organization?.id ==
          "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
          ? true
          : false,
      );

      setTitelErr("");
      setdesginationErr("");

      setGrossError("");
      if (
        state.FormsIDList.Job_offer_id != "" &&
        state.JOBOfferCall.JobDATATS.client_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_job_description == true &&
        state.JOBOfferCall.JobDATATS.client_id != null
      ) {
        console.log("aslkdklsajd joinings");

        dispatch(
          settheJobinfoBranchEmployeeProfile({
            value: state.JOBOfferCall.JobDATATS.client_id.id,
            label: state.JOBOfferCall.JobDATATS.client_id.client_name,
          }),
        );
      }
      // else if(state.JOBOfferCall.JobDATATS.client_id== undefined &&
      //   state.JOBOfferCall.JobDATATS.client_id == null) {
      //     dispatch(settheJobinfoBranchEmployeeProfile({value:"",label:"Select"}))

      // }

      dispatch(
        setTheGrossSalarayAmount(state.JOBOfferCall.JobDATATS.gross_salary),
      );
    }
  }, [
    state.JOBOfferCall.JobDATATS,
    siteObjectVal,
    state.FormsIDList.ActiveTabs,
  ]);

  useEffect(() => {
    if (
      // state.JOBOfferCall.JobDATATS.client_id == null &&state.JOBOfferCall.JobDATATS.client_id== undefined &&
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.is_job_description == true
    ) {
      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.client_id != null &&
        state.EmployeeProfile.EmployeeProfileList.client_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.is_job_description == true
      ) {
        console.log("aslkdklsajd joinings");

        dispatch(
          settheJobinfoBranchEmployeeProfile({
            value: state.EmployeeProfile.EmployeeProfileList.client_id.id,
            label:
              state.EmployeeProfile.EmployeeProfileList.client_id.client_name,
          }),
        );
      }
    } ///---job information inclient id
  }, [
    state.EmployeeProfile.EmployeeProfileList &&
    state.EmployeeProfile.EmployeeProfileList?.is_job_description == true,
  ]);

  const preventTyping = (e) => {
    const invalidKey =
      (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) || // Any printable character
      e.key === " " || // Space key
      e.key === "Tab" || // Tab key
      e.key === "Enter"; // Enter key

    if (invalidKey) {
      e.preventDefault();
    }
  };
  // useEffect(() => {
  //   if (branchId == "11a8ab83-0669-4098-a453-ddb2a2e0c39e") {
  //     const payloads = {
  //       search: SearchedVal.organizationRm_search,
  //       page_size: "20",
  //       page: 1,
  //       org_ids: "11a8ab83-0669-4098-a453-ddb2a2e0c39e",
  //     };
  //     dispatch(resetOrganizationRmFilterlist(payloads));
  //   }
  // }, [SearchedVal.organizationRm_search, data?.organization_id]);

  useEffect(() => {
    if (
      state.JOBOfferCall.JobDATATS.id != undefined &&
      state.FormsIDList.Job_offer_id == state.JOBOfferCall.JobDATATS.id &&
      state.FormsIDList.Job_offer_id != "" &&
      state.JOBOfferCall.JobDATATS.site_id != null &&
      state.JOBOfferCall.JobDATATS.site_id != undefined &&
      state.JOBOfferCall.JobDATATS.site_id.id != undefined
    ) {
      IDS = state.JOBOfferCall.JobDATATS.site_id.id;
      setSiteObjectVal({
        value: state.JOBOfferCall.JobDATATS.site_id.id,
        label: state.JOBOfferCall.JobDATATS.site_id.zone_name.toUpperCase(),
      });
      setSiteIDS(IDS);
      setRetrveeId(IDS);
    }
  }, [state.JOBOfferCall.JobDATATS]);
  //  console.log(state.FormsIDList.Job_offer_id, "JobOffers SetJObofferCallAction");
  ///////////////--------- next------APi-----Call

  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 3 &&
      state.FormsIDList.ActiveTabs == 10 &&
      state.FormsIDList.Idverify == "" &&
      state.BasicFormCreated.user_ID != undefined &&
      state.BasicFormCreated.user_ID != ""
    ) {
      const payload = {
        type: "IDF",
        // userId: state.BasicFormCreated.BacicDatas.user_id,
        userId: state.BasicFormCreated.user_ID,
      };
      dispatch(setPreviousDataFetchActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);
  useEffect(() => {
    if (
      state.FormsIDList.ActiveTabs == 10 &&
      // state.FormsIDList.Idverify == "" &&
      state.PreviousApiCallLine.PreviousDatas &&
      state.PreviousApiCallLine.PreviousDatas.id
    ) {
      dispatch(SetIdVeriications(state.PreviousApiCallLine.PreviousDatas.id));
    }
  }, [state.PreviousApiCallLine.PreviousDatas, state.FormsIDList.ActiveTabs]);

  // console.log(
  //   state.PreviousApiCallLine.PreviousDatas,
  //   "PreviousDatas",
  // );
  // console.log(
  //   state.FormsIDList.Idverify,
  //   "Idverify",
  //   state.PreviousApiCallLine.PreviousDatas.id
  // );

  console.log(
    data,
    "data.gross_salary",
    siteObjectVal,
    state.NumberCounts.ZONEobjects,
  );
  console.log(data, "daskjdkjaskdkjasd");
  const HandleNext = () => {
    var a = 0;

    if (state.FormsIDList.Job_offer_id == "") {
      // if(state.NumberCounts.Editable != 1){
      if (data.job_title == "") {
        a = 1;
        setTitelErr("*Zone is required");
      }

      if (data.designation_id == "") {
        a = 1;
        setdesginationErr("*Designation is required");
      }
      if (
        (jobinfo?.project_nature == "" ||
          jobinfo?.project_nature == null ||
          jobinfo?.project_nature == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setProjectNatureError("*Project Nature is required");
      }
      if (
        (jobinfo?.billabilty == "" ||
          jobinfo?.billabilty == null ||
          jobinfo?.billabilty == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBillingAbilityError("*Billing Ability is required");
      }
      if (
        (jobinfo?.billing_type == "" ||
          jobinfo?.billing_type == null ||
          jobinfo?.billing_type == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBillingTypeError("*Billing Type is required");
      }
      if (
        (data.rm_id == "" || data?.rm_id == null || data?.rm_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setRMError("*RM is required");
      }
      if (
        (data.pm_id == "" || data?.pm_id == null || data?.pm_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setPMError("*PM is required");
      }
      if (
        (data.vh_id == "" || data?.vh_id == null || data?.vh_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setVHError("*VH is required");
      }
      if (
        (data.medical_insurance == "" ||
          data.medical_insurance == null ||
          data.medical_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setMedicalInsuranceError("*Medical Insurance is required");
      }
      if (
        (data.accident_insurance == "" ||
          data.accident_insurance == null ||
          data.accident_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setAccidentInsuranceError("*Accident Insurance is required");
      }
      if (
        (data.premium_insurance == "" ||
          data.premium_insurance == null ||
          data.premium_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setPremiumInsuranceError("*Premium Insurance is required");
      }
      if (
        (data.variable_salary == "" ||
          data.variable_salary == null ||
          data.variable_salary == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setVariableError("*Variable Salary is required");
      }
      if (
        (data.stationary_bonus == "" ||
          data.stationary_bonus == null ||
          data.stationary_bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setStationaryError("*Stationary Bonus is required");
      }
      // if (
      //   (data.professional_tax == "" ||
      //     data.professional_tax == null ||
      //     data.professional_tax == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setProfessionalError("*Professional Tax is required");
      // }
      if (
        (data.bonus == "" || data.bonus == null || data.bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBonusError("*Bonus is required");
      }
      if (
        (data.mobile_expenses == "" ||
          data.mobile_expenses === null ||
          data.mobile_expenses == undefined) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
        )
      ) {
        a = 1;
        setMobileExpensesError("*Mobile Expenses is required");
      }
      if (
        (data.conveyance == "" ||
          data.conveyance == null ||
          data.conveyance == undefined) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ||
          organization?.organization?.id ==
          "28e108e0-a644-4365-89df-317867f00f22"
        )
      ) {
        a = 1;
        setConveyanceError("*Conveyance is required");
      }
      if (
        (data.retention_bonus == "" ||
          data.retention_bonus == null ||
          data.retention_bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setRetentionBonusError("*Retention Bonus is required");
      }

      // if (
      //   (data.hra_salary == "" ||
      //     data.hra_salary == null ||
      //     data.hra_salary == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setHraErr("*HRA Salary is required");
      // }

      // if (
      //   (data.lwf_employee == "" ||
      //     data.lwf_employee == null ||
      //     data.lwf_employee == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setLwfError("*LWF Employee is required");
      // }
      if (
        (data.ca_salary == "" ||
          data.ca_salary == null ||
          data.ca_salary == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setCAError("*CA Salary is required");
      }

      if (data.gross_salary == "") {
        a = 1;
        setGrossError("*Salary  is required");
      }
      if (data.gross_salary != "" && data.gross_salary == 0) {
        a = 1;
        setGrossError("*Indicative Salary must be greater than 0.");
      }
      if (data.gross_salary != "" && data?.gross_salary?.length > 8) {
        a = 1;
        setGrossError("*Indicative Salary cannot exceed 8 digits");
      }

      if (
        data.basic_salary !== "" &&
        data.basic_salary !== null &&
        data?.basic_salary?.length > 8
      ) {
        a = 1;
        setBasicErr("*Basic Salary cannot exceed 8 digits.");
      }
      if (
        data.basic_salary == "" &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBasicErr("*Basic Salary is required.");
      }

      if (
        data.hra_salary !== "" &&
        data.hra_salary !== null &&
        data.hra_salary.length > 8
      ) {
        a = 1;
        setHraErr("*HRA Salary cannot exceed 8 digits.");
      }
      if (
        data.hra_salary == "" &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setHraErr("*HRA Salary is required.");
      }

      if (
        data.other_allowances_salary !== "" &&
        data.other_allowances_salary !== null &&
        data.other_allowances_salary.length > 8
      ) {
        a = 1;
        setOtherErr("*Other Allowances cannot exceed 8 digits.");
      }

      if (
        data.employee_ESI !== "" &&
        data.employee_ESI !== null &&
        data.employee_ESI.length > 8
      ) {
        a = 1;
        setESIerr("*ESI cannot exceed 8 digits.");
      }

      if (
        data.employee_PF !== "" &&
        data.employee_PF !== null &&
        data.employee_PF.length > 8
      ) {
        a = 1;
        setPFerr("*PF cannot exceed 8 digits.");
      }

      if (
        data.net_salary !== "" &&
        data.net_salary !== null &&
        data.net_salary.length > 8
      ) {
        a = 1;
        setNetSalarErr("*Net Salary cannot exceed 8 digits.");
      }

      if (
        data.airtime_allowance !== "" &&
        data.airtime_allowance !== null &&
        data.airtime_allowance.length > 8
      ) {
        a = 1;
        setAirTimeAllo("*Airtime Allowance cannot exceed 8 digits.");
      }

      if (
        isAthena &&
        canEditDivisionLevel &&
        divisionLevelOptions.length > 0 &&
        toDivisionLevelList(data.division_level).length == 0
      ) {
        a = 1;
        setDivisionLevelError("*Division Level is required");
      }

      if (data.client_id == "") {
        setbranchMantory("*Client is required");
      }
      // }

      if (state.NumberCounts.BranchObjectJobInfoFieldAgent) {
        if (
          state.NumberCounts.BranchObjectJobInfoFieldAgent?.label
            ?.toLowerCase()
            .includes("sony india") ||
          siteObjectVal?.label?.toLowerCase().includes("avon")
        ) {
          if (jobinfo?.end_date == null || jobinfo?.end_date == "") {
            if (jobinfo?.job_status == 1) {
              a = 1;
              setend_daterr("*End date is required");
            }
          }
        }
      }

      // ErrorInde == 0
      // console.log(data, "asdasdasd" , state.EmployeeProfile.EmployeeProfileList.id , state.BasicFormCreated.BasciFormCreate);
      if (a == 0 && ErrorInde == 0) {
        dispatch(setTherossSalaryCreateActions(data.gross_salary));
        const Jobinfocreate = {
          site_id: data.job_title,
          // department: payload.payload.data.department,
          department: "wbs",
          designation_id: data.designation_id,
          gross_salary: data.gross_salary,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          client_id: data.client_id,
          other_allowances_salary:
            addbasic == true ? data.other_allowances_salary : "",
          airtime_allowance: addbasic == true ? data.airtime_allowance : "",
          net_salary: addbasic == true ? data.net_salary : "",
          hra_salary: addbasic == true ? data.hra_salary : "",
          employee_PF: addbasic == true ? data.employee_PF : "",
          employee_ESI: addbasic == true ? data.employee_ESI : "",
          basic_salary: addbasic == true ? data.basic_salary : "",
          rm_id: data.rm_id,
          pm_id: data.pm_id,
          vh_id: data.vh_id,
          project_code: data.project_code,
          program_code: data.program_code,
          client_code: data.client_code,
          division_code: data.division_code,
          division_name: data.division_name,
          medical_insurance: data.medical_insurance,
          // athena
          joining_bonus: data.joining_bonus,
          entertainment_reimbursement: data.entertainment_reimbursement,
          Stipend: data.Stipend,
          advance_bonus: data.advance_bonus,
          product_code: data.product_code,
          division_level: toDivisionLevelList(data.division_level).slice(0, 1),

          // end athena
          accident_insurance: data.accident_insurance,
          premium_insurance: data.premium_insurance,
          variable_salary: data.variable_salary,
          stationary_bonus: data.stationary_bonus,
          // professional_tax: data.professional_tax,
          bonus: data.bonus,
          mobile_expenses: data.mobile_expenses,
          conveyance: data.conveyance,
          retention_bonus: data.retention_bonus,
          is_gratuity: data.is_gratuity,
          // lwf_employee: data.lwf_employee,
          da_salary: data.da_salary,
          ca_salary: data.ca_salary,
          swa_salary: data.swa_salary,
          project_nature: jobinfo.project_nature,
          billabilty: jobinfo.billabilty,
          billing_type: jobinfo.billing_type,
          other_calculated_salary: state?.JOBOfferPreviewCall
            ?.JobOfferPreivewData
            ? state?.JOBOfferPreviewCall?.JobOfferPreivewData
            : null,
        };
        const Jobinfocreate_withend = {
          site_id: data.job_title,
          // department: payload.payload.data.department,
          department: "wbs",
          designation_id: data.designation_id,
          gross_salary: data.gross_salary,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          client_id: data.client_id,
          other_allowances_salary:
            addbasic == true ? data.other_allowances_salary : "",
          airtime_allowance: addbasic == true ? data.airtime_allowance : "",
          net_salary: addbasic == true ? data.net_salary : "",
          hra_salary: addbasic == true ? data.hra_salary : "",
          employee_PF: addbasic == true ? data.employee_PF : "",
          employee_ESI: addbasic == true ? data.employee_ESI : "",
          basic_salary: addbasic == true ? data.basic_salary : "",
          end_date: jobinfo?.job_status == 1 ? jobinfo?.end_date : null,
          job_status: jobinfo?.job_status,
          da_salary: data.da_salary,
          ca_salary: data.ca_salary,
          swa_salary: data.swa_salary,
        };
        const payload = {
          data: data,
          // Jobinfocreate:Jobinfocreate,

          Jobinfocreate:
            (state.NumberCounts.BranchObjectJobInfoFieldAgent &&
              state.NumberCounts.BranchObjectJobInfoFieldAgent?.label
                ?.toLowerCase()
                .includes("sony india")) ||
              siteObjectVal?.label?.toLowerCase().includes("avon")
              ? Jobinfocreate_withend
              : Jobinfocreate,

          // Jobinfocreate_withend
          // timeline_id: state.BasicFormCreated.BasciFormCreate,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          designation_id: data.designation_id,
          //timeline_id: state.EmployeeProfile.EmployeeProfileList.id,
        };
        console.log(payload, "dakljdkjlajkdalkdalksdlalksaaqweq");
        dispatch(SetJObofferCallAction(payload));
      }
    } else if (
      // (state.FormsIDList.Job_offer_id != "" &&
      //   state.JOBOfferCall.JobDATATS != [] ) &&
      //   // data.department != state.JOBOfferCall.JobDATATS.department) ||
      // data.designation_id != state.NumberCounts.RoleOjects.value ||
      // // data.gross_salary != state.JOBOfferCall.JobDATATS.gross_salary ||
      // data.job_title != retrievedid

      (state.FormsIDList.Job_offer_id != "" &&
        state.JOBOfferCall.JobDATATS != [] &&
        // data.department != state.JOBOfferCall.JobDATATS.department) ||
        data.designation_id !=
        state.JOBOfferCall.JobDATATS.designation_id?.id) ||
      data.gross_salary != state.JOBOfferCall.JobDATATS.gross_salary ||
      data.job_title != retrievedid ||
      data.client_id != state.JOBOfferCall.JobDATATS.client_id?.id ||
      data.other_allowances_salary !=
      state.JOBOfferCall.JobDATATS.other_allowances_salary ||
      data.net_salary != state.JOBOfferCall.JobDATATS.net_salary ||
      data.hra_salary != state.JOBOfferCall.JobDATATS.hra_salary ||
      data.employee_PF != state.JOBOfferCall.JobDATATS.employee_PF ||
      data.employee_ESI != state.JOBOfferCall.JobDATATS.employee_ESI ||
      data.basic_salary != state.JOBOfferCall.JobDATATS.basic_salary ||
      data.airtime_allowance !=
      state.JOBOfferCall.JobDATATS.airtime_allowance ||
      jobinfo.end_date != state.JOBOfferCall.JobDATATS.end_date ||
      jobinfo.job_status != state.JOBOfferCall.JobDATATS.job_status
    ) {
      //  if(state.NumberCounts.Editable != 1){
      if (data.job_title == "") {
        a = 1;
        setTitelErr("*Zone is required");
      }
      if (data.designation_id == "") {
        a = 1;
        setdesginationErr("*Designation is required");
      }
      if (
        (jobinfo?.project_nature == "" ||
          jobinfo?.project_nature == null ||
          jobinfo?.project_nature == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setProjectNatureError("*Project Nature is required");
      }
      if (
        (jobinfo?.billabilty == "" ||
          jobinfo?.billabilty == null ||
          jobinfo?.billabilty == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBillingAbilityError("*Billing Ability is required");
      }
      if (
        (jobinfo?.billing_type == "" ||
          jobinfo?.billing_type == null ||
          jobinfo?.billing_type == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBillingTypeError("*Billing Type is required");
      }
      if (
        (data.rm_id == "" || data?.rm_id == null || data?.rm_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setRMError("*RM is required");
      }
      if (
        (data.pm_id == "" || data?.pm_id == null || data?.pm_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setPMError("*PM is required");
      }
      if (
        (data.vh_id == "" || data?.vh_id == null || data?.vh_id == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setVHError("*VH is required");
      }
      if (
        (data.medical_insurance == "" ||
          data.medical_insurance == null ||
          data.medical_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setMedicalInsuranceError("*Medical Insurance is required");
      }
      if (
        (data.accident_insurance == "" ||
          data.accident_insurance == null ||
          data.accident_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setAccidentInsuranceError("*Accident Insurance is required");
      }
      if (
        (data.premium_insurance == "" ||
          data.premium_insurance == null ||
          data.premium_insurance == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setPremiumInsuranceError("*Premium Insurance is required");
      }
      if (
        (data.variable_salary == "" ||
          data.variable_salary == null ||
          data.variable_salary == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setVariableError("*Variable Salary is required");
      }
      if (
        (data.stationary_bonus == "" ||
          data.stationary_bonus == null ||
          data.stationary_bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setStationaryError("*Stationary Bonus is required");
      }
      // if (
      //   (data.professional_tax == "" ||
      //     data.professional_tax == null ||
      //     data.professional_tax == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setProfessionalError("*Professional Tax is required");
      // }

      if (
        (data.bonus == "" || data.bonus == null || data.bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBonusError("*Bonus is required");
      }
      if (
        (data.mobile_expenses == "" ||
          data.mobile_expenses === null ||
          data.mobile_expenses == undefined) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"

        )
      ) {
        a = 1;
        setMobileExpensesError("*Mobile Expenses is required");
      }
      if (
        (data.conveyance == "" ||
          data.conveyance == null ||
          data.conveyance == undefined) &&
        (organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e" ||
          organization?.organization?.id ==
          "28e108e0-a644-4365-89df-317867f00f22"
        )
      ) {
        a = 1;
        setConveyanceError("*Conveyance is required");
      }
      if (
        (data.retention_bonus == "" ||
          data.retention_bonus == null ||
          data.retention_bonus == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setRetentionBonusError("*Retention Bonus is required");
      }
      // if (
      //   (data.hra_salary == "" ||
      //     data.hra_salary == null ||
      //     data.hra_salary == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setHraErr("*HRA Salary is required");
      // }
      // if (
      //   (data.lwf_employee == "" ||
      //     data.lwf_employee == null ||
      //     data.lwf_employee == undefined) &&
      //   organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      // ) {
      //   a = 1;
      //   setLwfError("*LWF Employee is required");
      // }
      if (
        (data.ca_salary == "" ||
          data.ca_salary == null ||
          data.ca_salary == undefined) &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setCAError("*CA Salary is required");
      }

      if (data.gross_salary == "") {
        a = 1;
        setGrossError("*Salary  is required");
      }
      if (data.gross_salary != "" && data.gross_salary == 0) {
        a = 1;
        setGrossError("*Indicative Salary must be greater than 0.");
      }
      if (
        data.gross_salary != "" &&
        data.gross_salary != null &&
        data.gross_salary.length > 8
      ) {
        a = 1;
        setGrossError("*Indicative Salary cannot exceed 8 digits");
      }

      if (
        isAthena &&
        canEditDivisionLevel &&
        divisionLevelOptions.length > 0 &&
        toDivisionLevelList(data.division_level).length == 0
      ) {
        a = 1;
        setDivisionLevelError("*Division Level is required");
      }

      if (data.client_id == "") {
        setbranchMantory("*Client is required");
        a = 1;
      }

      if (
        data.basic_salary !== "" &&
        data.basic_salary !== null &&
        data.basic_salary.length > 8
      ) {
        a = 1;
        setBasicErr("*Basic Salary cannot exceed 8 digits.");
      }
      if (
        data.basic_salary == "" &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setBasicErr("*Basic Salary is required.");
      }

      if (
        data.hra_salary !== "" &&
        data.hra_salary !== null &&
        data.hra_salary.length > 8
      ) {
        a = 1;
        setHraErr("*HRA Salary cannot exceed 8 digits.");
      }
      if (
        data.hra_salary == "" &&
        organization?.organization?.id == "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
      ) {
        a = 1;
        setHraErr("*HRA Salary is required.");
      }
      if (
        data.other_allowances_salary !== "" &&
        data.other_allowances_salary !== null &&
        data.other_allowances_salary.length > 8
      ) {
        a = 1;
        setOtherErr("*Other Allowances cannot exceed 8 digits.");
      }

      if (
        data.employee_ESI !== "" &&
        data.employee_ESI !== null &&
        data.employee_ESI.length > 8
      ) {
        a = 1;
        setESIerr("*ESI cannot exceed 8 digits.");
      }

      if (
        data.employee_PF !== "" &&
        data.employee_PF !== null &&
        data.employee_PF.length > 8
      ) {
        a = 1;
        setPFerr("*PF cannot exceed 8 digits.");
      }

      if (
        data.net_salary !== "" &&
        data.net_salary !== null &&
        data.net_salary.length > 8
      ) {
        a = 1;
        setNetSalarErr("*Net Salary cannot exceed 8 digits.");
      }

      if (
        data.airtime_allowance !== "" &&
        data.airtime_allowance !== null &&
        data.airtime_allowance.length > 8
      ) {
        a = 1;
        setAirTimeAllo("*Airtime Allowance cannot exceed 8 digits.");
      }

      if (state.NumberCounts.BranchObjectJobInfoFieldAgent) {
        if (
          state.NumberCounts.BranchObjectJobInfoFieldAgent?.label
            ?.toLowerCase()
            .includes("sony india") ||
          siteObjectVal?.label?.toLowerCase().includes("avon")
        ) {
          if (jobinfo?.end_date == null || jobinfo?.end_date == "") {
            if (jobinfo?.job_status == 1) {
              a = 1;
              setend_daterr("*End date is required");
            }
          }
        }
      }
      // }

      // if (data.department == "") {
      //   a = 1;
      //   sedepartmentErr("* Department is required");
      // }

      // ErrorInde == 0
      if (a == 0 && ErrorInde == 0) {
        dispatch(setTherossSalaryActions(data.gross_salary)); //----if--the gross salary is more than 20,000 then only the pan card is important
        const Jobinfocreate = {
          site_id: data.job_title,
          // department: payload.payload.data.department,
          department: "wbs",
          designation_id: data.designation_id,
          gross_salary: data.gross_salary,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          client_id: data.client_id,
          other_allowances_salary:
            addbasic == true ? data.other_allowances_salary : "",
          airtime_allowance: addbasic == true ? data.airtime_allowance : "",
          net_salary: addbasic == true ? data.net_salary : "",
          hra_salary: addbasic == true ? data.hra_salary : "",
          employee_PF: addbasic == true ? data.employee_PF : "",
          employee_ESI: addbasic == true ? data.employee_ESI : "",
          basic_salary: addbasic == true ? data.basic_salary : "",
          rm_id: data.rm_id,
          pm_id: data.pm_id,
          vh_id: data.vh_id,
          project_code: data.project_code,

          program_code: data.program_code,
          client_code: data.client_code,
          division_code: data.division_code,
          division_name: data.division_name,
          medical_insurance: data.medical_insurance,
          // Athena
          joining_bonus: data.joining_bonus,
          entertainment_reimbursement: data.entertainment_reimbursement,
          Stipend: data.Stipend,
          advance_bonus: data.advance_bonus,
          product_code: data.product_code,
          division_level: toDivisionLevelList(data.division_level).slice(0, 1),
          // end athena
          accident_insurance: data.accident_insurance,
          premium_insurance: data.premium_insurance,
          variable_salary: data.variable_salary,
          stationary_bonus: data.stationary_bonus,
          // professional_tax: data.professional_tax,
          bonus: data.bonus,
          mobile_expenses: data.mobile_expenses,
          conveyance: data.conveyance,
          retention_bonus: data.retention_bonus,
          is_gratuity: data.is_gratuity,
          // lwf_employee: data.lwf_employee,
          da_salary: data.da_salary,
          ca_salary: data.ca_salary,
          swa_salary: data.swa_salary,
          project_nature: jobinfo.project_nature,
          billabilty: jobinfo.billabilty,
          billing_type: jobinfo.billing_type,
          other_calculated_salary: state?.JOBOfferPreviewCall
            ?.JobOfferPreivewData
            ? state?.JOBOfferPreviewCall?.JobOfferPreivewData
            : null,
        };

        const Jobinfocreate_withend = {
          site_id: data.job_title,
          // department: payload.payload.data.department,
          department: "wbs",
          designation_id: data.designation_id,
          gross_salary: data.gross_salary,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
          client_id: data.client_id,
          other_allowances_salary:
            addbasic == true ? data.other_allowances_salary : "",
          airtime_allowance: addbasic == true ? data.airtime_allowance : "",
          net_salary: addbasic == true ? data.net_salary : "",
          hra_salary: addbasic == true ? data.hra_salary : "",
          employee_PF: addbasic == true ? data.employee_PF : "",
          employee_ESI: addbasic == true ? data.employee_ESI : "",
          basic_salary: addbasic == true ? data.basic_salary : "",
          end_date: jobinfo?.job_status == 1 ? jobinfo?.end_date : null,
          job_status: jobinfo?.job_status,
        };
        const payload = {
          data: data,
          Jobinfocreate:
            (state.NumberCounts.BranchObjectJobInfoFieldAgent &&
              state.NumberCounts.BranchObjectJobInfoFieldAgent?.label
                ?.toLowerCase()
                .includes("sony india")) ||
              siteObjectVal?.label?.toLowerCase().includes("avon")
              ? Jobinfocreate_withend
              : Jobinfocreate,
          // timeline_id:
          //   SubRoleList != 0
          //     ? state.BasicFormCreated.BasciFormCreate
          //     : state.EmployeeProfile.EmployeeProfileList.id,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,

          // designation_id: state.NumberCounts.RoleOjects.value,
          designation_id: data.designation_id,
          Retieveid: state.FormsIDList.Job_offer_id,
          da_salary: data.da_salary,
          ca_salary: data.ca_salary,
          swa_salary: data.swa_salary,
        };
        dispatch(SetJObofferDITCallAction(payload));
      }
    } else if (
      state.FormsIDList.Job_offer_id != "" &&
      state.JOBOfferCall.JobDATATS != [] &&
      // data.designation_id == state.NumberCounts.RoleOjects.value &&
      data.designation_id == state.JOBOfferCall.JobDATATS.designation_id?.id &&
      data.client_id == state.JOBOfferCall.JobDATATS.client_id?.id &&
      // data.department == state.JOBOfferCall.JobDATATS.department &&
      // data.designation == state.JOBOfferCall.JobDATATS.designation &&
      data.gross_salary == state.JOBOfferCall.JobDATATS.gross_salary &&
      data.job_title == retrievedid &&
      data.other_allowances_salary ==
      state.JOBOfferCall.JobDATATS.other_allowances_salary &&
      data.net_salary == state.JOBOfferCall.JobDATATS.net_salary &&
      data.hra_salary == state.JOBOfferCall.JobDATATS.hra_salary &&
      data.employee_PF == state.JOBOfferCall.JobDATATS.employee_PF &&
      data.employee_ESI == state.JOBOfferCall.JobDATATS.employee_ESI &&
      data.basic_salary == state.JOBOfferCall.JobDATATS.basic_salary
    ) {
      dispatch(SetActiveTabs(3));
    }
    setSalaryPreviewPopup(false);
  };
  const HandlePrevious = () => {
    dispatch(SetActiveTabs(2));
  };

  // console.log( (state.NumberCounts.Editable === 2 ||
  //   state.ClientBranchIDs.SUBROLE === 0 || state.ClientBranchIDs.SUBROLE === 1) &&
  //   state.NumberCounts.EmployeeFormFIll != false ,"aisudi validation check point",
  //   state.NumberCounts.Editable ,
  //   state.NumberCounts.EmployeeFormFIll ,

  //   state.NumberCounts.EmployeeFormFIll != false &&
  //   (state.NumberCounts.Editable == 2 ||
  //   state.ClientBranchIDs.SUBROLE == 0 || state.ClientBranchIDs.SUBROLE == 1)

  // );
  //   console.log(    state.NumberCounts.EmployeeFormFIll != false &&
  //     (state.NumberCounts.Editable == 2 ||
  //     state.ClientBranchIDs.SUBROLE == 0 || state.ClientBranchIDs.SUBROLE == 1) ,
  //     "state.ClientBranchIDs.",
  //     state.NumberCounts.EmployeeFormFIll
  //  );

  console.log(
    state.NumberCounts.BranchObjectJobInfoFieldAgent,
    "state.NumberCounts.BranchObjectJobInfoFieldAgent client",
    siteObjectVal,
    siteObjectVal?.label?.includes("AVON"),
  );
  const handleInputOrganizationRm = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organizationRm_search: Val,
    });
  };
  const handleRM_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      // let objectAi = [];
      setOrganization_RM_Val(e);
      // e.map((item) => {
      //   objectAi.push(item.value);
      // });
      setData({
        ...data,
        rm_id: e.value,
      });
    }
  };
  const handlePM_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      // let objectAi = [];
      setOrganization_PM_Val(e);
      // e.map((item) => {
      //   objectAi.push(item.value);
      // });
      setData({
        ...data,
        pm_id: e.value,
      });
    }
  };
  const handleVH_List = (e) => {
    console.log(e, "dakllkdakldklas");
    if (e != null) {
      // let objectAi = [];
      setOrganization_VH_Val(e);
      // e.map((item) => {
      //   objectAi.push(item.value);
      // });
      setData({
        ...data,
        vh_id: e.value,
      });
    }
  };
  console.log(
    state?.JOBOfferPreviewCall?.JobOfferPreivewData,
    "dklaskldaskldklas",
  );

  const HandlePreview = () => {
    console.log(data, "daskjdjkajsda");

    if (
      data?.basic_salary !== "" &&
      data?.hra_salary !== "" &&
      data?.ca_salary !== "" &&
      data?.stationary_bonus !== "" &&
      data?.variable_salary !== "" &&
      data?.medical_insurance !== "" &&
      data?.accident_insurance !== "" &&
      data?.premium_insurance !== "" &&
      // data?.premium_insurance !== "" &&
      // data?.professional_tax !== "" &&
      // data?.lwf_employee !== "" &&
      data?.gross_salary !== "" &&
      data?.bonus !== "" &&
      data?.mobile_expenses !== "" &&
      data?.conveyance !== "" &&
      data?.retention_bonus !== ""
    ) {
      const jobOfferPreviewpayload = {
        payload: {
          basic_salary: Number(data.basic_salary),
          hra_salary: Number(data.hra_salary),
          ca_salary: Number(data.ca_salary),
          stationary_bonus: Number(data.stationary_bonus),
          variable_salary: Number(data.variable_salary),
          medical_insurance: Number(data.medical_insurance),
          accident_insurance: Number(data.accident_insurance),
          premium_insurance: Number(data.premium_insurance),
          // premium_insurance: Number(data.premium_insurance),
          // professional_tax: Number(data.professional_tax),
          // lwf_employee: Number(data.lwf_employee),
          gross_salary: Number(data.gross_salary),
          bonus: Number(data.bonus),
          mobile_expenses: Number(data.mobile_expenses),
          conveyance: Number(data.conveyance),
          retention_bonus: Number(data.retention_bonus),
          is_gratuity: data.is_gratuity,
          timeline_id:
            state.BasicFormCreated.BasciFormCreate == ""
              ? state.EmployeeProfile.EmployeeProfileList.id
              : state.BasicFormCreated.BasciFormCreate,
        },
        setSalaryPreviewPopup,
      };
      dispatch(SetJObofferPreviewCallAction(jobOfferPreviewpayload));
    } else {
      toast.error("Please fill all the fields");
    }
  };

  return (
    <div>
      <div className=" BodyContent jobOfferIngfor">
        <div className="card">
          <div className="card-body cards ">
            <div className="UserPoup">
              <div className="BeforForms">
                <div className="Form">
                  <div className="ModalHeader">
                    <div>
                      <span>Job Information</span>
                    </div>
                  </div>
                  <div className="Modal-Body ModalForms">
                    <div className="row">
                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Site
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          menuPlacement="top"
                          //  className="Selects "
                          styles={{ position: "relative", top: "60px" }}
                          isDisabled={
                            // state.NumberCounts.Editable == 1 && state.ClientBranchIDs.SUBROLE != 3 ? true : false
                            state.NumberCounts.Editable == 2 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? true
                              : state.NumberCounts.EmployeeFormFIll == false &&
                                state.NumberCounts.Editable == 1 &&
                                (state.ClientBranchIDs.SUBROLE != 3 ||
                                  state.ClientBranchIDs.SUBROLE == 0 ||
                                  state.ClientBranchIDs.SUBROLE == 1)
                                ? //  false
                                true
                                : state.NumberCounts.EmployeeFormFIll == true &&
                                  state.ClientBranchIDs.SUBROLE == 2
                                  ? true
                                  : state.NumberCounts.Editable == 2
                                    ? true
                                    : state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : false
                          }
                          onChange={(e) => {
                            handleBranchChange(e);
                            setTitelErr("");
                          }}
                          name="BranchSearch"
                          onInputChange={handleInputChangeZone}
                          options={branchoptions}
                          labelledBy="Select"
                          value={siteObjectVal}
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {jobtotitleErr}
                        </p>
                      </div>

                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Client
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          styles={{ position: "relative", top: "60px" }}
                          menuPlacement="top"
                          isDisabled={
                            // state.NumberCounts.Editable == 2
                            // ?
                            //  true:
                            //  state.NumberCounts.Editable == 1 &&
                            //  state.ClientBranchIDs.SUBROLE == 3 ||
                            //  state.ClientBranchIDs.SUBROLE == 0
                            //  ||
                            //  state.ClientBranchIDs.SUBROLE == 1  &&
                            //  state.NumberCounts.EmployeeFormFIll == false
                            //  ?
                            //  false :
                            //  state.ClientBranchIDs.SUBROLE ==2  && state.NumberCounts.EmployeeFormFIll == true ?
                            //  true :
                            //  false

                            state.NumberCounts.Editable == 2 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? true
                              : state.NumberCounts.EmployeeFormFIll == false &&
                                state.NumberCounts.Editable == 1 &&
                                (state.ClientBranchIDs.SUBROLE != 3 ||
                                  state.ClientBranchIDs.SUBROLE == 0 ||
                                  state.ClientBranchIDs.SUBROLE == 1)
                                ? //  false
                                true
                                : state.NumberCounts.EmployeeFormFIll == true &&
                                  state.ClientBranchIDs.SUBROLE == 2
                                  ? true
                                  : state.NumberCounts.Editable == 2
                                    ? true
                                    : false
                          }
                          onChange={(e) => {
                            HandleBranchChanges(e);
                            setbranchMantory("");
                          }}
                          name="BranchSearch"
                          labelledBy="Select"
                          options={nameList4}
                          value={
                            state.NumberCounts.BranchObjectJobInfoFieldAgent
                          }
                          onInputChange={HandleInputBranch}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {branchMantory}
                        </p>
                      </div>

                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Designation
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          className="Selects stateNames"
                          styles={{ position: "relative", top: "60px" }}
                          menuPlacement="top"
                          onChange={(e) => {
                            handleDesignationChange(e);
                            setdesginationErr("");
                          }}
                          isDisabled={
                            // state.NumberCounts.Editable == 1 &&
                            // SubRoleList != 0 &&
                            // SubRoleList != 1 &&
                            // state.ClientBranchIDs.SUBROLE != 3 &&
                            // state.NumberCounts.EmployeeFormFIll == true
                            //   ? true
                            //   : false

                            state.NumberCounts.Editable == 2 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? true
                              : state.NumberCounts.EmployeeFormFIll == false &&
                                state.NumberCounts.Editable == 1 &&
                                (state.ClientBranchIDs.SUBROLE != 3 ||
                                  state.ClientBranchIDs.SUBROLE == 0 ||
                                  state.ClientBranchIDs.SUBROLE == 1)
                                ? //  false
                                true
                                : state.NumberCounts.EmployeeFormFIll == true &&
                                  state.ClientBranchIDs.SUBROLE == 2
                                  ? true
                                  : false
                          }
                          name="roleSearch"
                          onInputChange={handleInputRoleChange}
                          options={roleoptionsList}
                          value={RoleValue}
                          labelledBy="Select"
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                              state.NumberCounts.EmployeeFormFIll == true
                              ? true
                              : false
                          }
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {designationerr}
                        </p>
                      </div>

                      <div className="col-sm-3 mt-3">
                        <label for="validationCustom01" class="form-label">
                          Indicative Salary
                        </label>

                        <span style={{ color: "red" }}>* </span>

                        <NumericFormat
                          thousandSeparator={true}
                          onValueChange={(values) => {
                            const { value } = values;

                            // Parse the value as a number
                            const parsedValue = parseFloat(value);

                            // Check if input exceeds 8 digits
                            if (value.length > 8) {
                              setGrossError(
                                "*Indicative Salary cannot exceed 8 digits.",
                              );
                              setErrInde(1);
                              // Revert to previous valid value
                              setData({
                                ...data,
                                gross_salary: data.gross_salary, // keep the previous value
                              });
                              return;
                            }

                            // Check if input is less than or equal to 0
                            if (parsedValue <= 0) {
                              setGrossError(
                                "*Indicative Salary must be greater than 0.",
                              );
                              setErrInde(1);
                              // Clear the field
                              setData({
                                ...data,
                                gross_salary: "",
                              });
                              return;
                            }

                            // Valid input
                            setGrossError("");
                            setErrInde(0);
                            setData({
                              ...data,
                              gross_salary: value,
                            });
                          }}
                          autocomplete="off"
                          name="gross_salary"
                          value={data.gross_salary}
                          isNumericString
                          displayType={"input"}
                          fixedDecimalScale={true}
                          className="form-control FormalFiledReport"
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                              state.ClientBranchIDs.SUBROLE != 0 &&
                              state.ClientBranchIDs.SUBROLE != 1 &&
                              state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE == 3
                                ? false
                                : state.ClientBranchIDs.SUBROLE == 0 &&
                                  state.NumberCounts.EmployeeFormFIll == true
                                  ? false
                                  : state.ClientBranchIDs.SUBROLE == 0 &&
                                    state.NumberCounts.EmployeeFormFIll ==
                                    false
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                      true &&
                                      state.ClientBranchIDs.SUBROLE == 1
                                      ? false
                                      : state.NumberCounts.Editable == 2
                                        ? false
                                        : true
                          }
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                              state.ClientBranchIDs.SUBROLE != 0 &&
                              state.ClientBranchIDs.SUBROLE != 1 &&
                              state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE == 3
                                ? false
                                : state.ClientBranchIDs.SUBROLE == 0 &&
                                  state.NumberCounts.EmployeeFormFIll == true
                                  ? false
                                  : state.ClientBranchIDs.SUBROLE == 0 &&
                                    state.NumberCounts.EmployeeFormFIll ==
                                    false
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                      true &&
                                      state.ClientBranchIDs.SUBROLE == 1
                                      ? false
                                      : state.NumberCounts.Editable == 2
                                        ? false
                                        : true
                          }
                        />

                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {grossSalaryErr}
                        </p>
                      </div>
                      {organization?.organization?.id ==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <>
                            {" "}
                            <div className="col-sm-3 mt-3">
                              <label class="form-label">
                                RM
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                className="Selects "
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                onChange={(e) => {
                                  handleRM_List(e);
                                  setRMError("");
                                }}
                                options={rmOptionList}
                                labelledBy="Select"
                                value={organization_RM_Val}
                              // onInputChange={handleInputOrganizationRm}
                              />
                              <p className="Error">{rmError}</p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label class="form-label">
                                PM
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                className="Selects "
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                // isMulti
                                onChange={(e) => {
                                  handlePM_List(e);
                                  setPMError("");
                                }}
                                options={pmOptionList}
                                labelledBy="Select"
                                value={organization_PM_Val}
                              // onInputChange={handleInputOrganizationRm}
                              />
                              <p className="Error">{pmError}</p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label class="form-label">
                                VH
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                className="Selects "
                                styles={{
                                  position: "relative",
                                  top: "60px",
                                }}
                                onChange={(e) => {
                                  handleVH_List(e);
                                  setVHError("");
                                }}
                                // isMulti
                                options={vhOptionList}
                                labelledBy="Select"
                                value={organization_VH_Val}
                              // onInputChange={handleInputOrganizationRm}
                              />
                              <p className="Error">{vhError}</p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Project Code
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="project_code"
                                value={data?.project_code}
                                disabled
                                onChange={(e) => {
                                  HandleChanges(e);
                                  // setClientNaaErr("");
                                }}
                              />
                            </div>
                          </>
                        )}
                      {organization?.organization?.id ==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Program Code
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="program_code"
                                value={data?.program_code}
                                disabled
                                onChange={(e) => {
                                  HandleChanges(e);
                                  // setClientNaaErr("");
                                }}
                              />
                              {/* <p className="Error"> {clientNameEr} </p> */}
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Client Code
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="client_code"
                                value={data?.client_code}
                                disabled
                                onChange={(e) => {
                                  HandleChanges(e);
                                  // setClientNaaErr("");
                                }}
                              />
                              {/* <p className="Error"> {clientNameEr} </p> */}
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Division Code
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="division_code"
                                disabled
                                value={data?.division_code}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  // setClientNaaErr("");
                                }}
                              />
                              {/* <p className="Error"> {clientNameEr} </p> */}
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Division Name
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="division_name"
                                value={data?.division_name}
                                disabled
                                onChange={(e) => {
                                  HandleChanges(e);
                                  // setClientNaaErr("");
                                }}
                              />
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Medical Insurance
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="medical_insurance"
                                value={data?.medical_insurance}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setMedicalInsuranceError("");
                                }}
                              />
                              <p className="Error"> {medicalInsuranceError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Accident Insurance
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="accident_insurance"
                                value={data?.accident_insurance}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setAccidentInsuranceError("");
                                }}
                              />
                              <p className="Error"> {accidentInsuranceError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Premium Insurance
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="premium_insurance"
                                value={data?.premium_insurance}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setPremiumInsuranceError("");
                                }}
                              />
                              <p className="Error"> {premiumInsuranceError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Variable Salary
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="variable_salary"
                                value={data?.variable_salary}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setVariableError("");
                                }}
                              />
                              <p className="Error"> {variableSalaryError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Statutory bonus
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="stationary_bonus"
                                value={data?.stationary_bonus}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setStationaryError("");
                                }}
                              />
                              <p className="Error"> {stationaryError} </p>
                            </div>
                            {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Professional Tax
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="professional_tax"
                              value={data?.professional_tax}
                              onChange={(e) => {
                                HandleChanges(e);
                                setProfessionalError("");
                              }}
                            />
                            <p className="Error"> {professionalError} </p>
                          </div> */}
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Bonus
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="bonus"
                                value={data?.bonus}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setBonusError("");
                                }}
                              />
                              <p className="Error"> {bonusError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Mobile Expenses
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="mobile_expenses"
                                value={data?.mobile_expenses}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setMobileExpensesError("");
                                }}
                              />
                              <p className="Error"> {mobileExpensesError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Conveyance Reimbursement
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="conveyance"
                                value={data?.conveyance}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setConveyanceError("");
                                }}
                              />
                              <p className="Error"> {conveyanceError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label for="validationCustom01" class="form-label">
                                Retention Bonus
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="retention_bonus"
                                value={data?.retention_bonus}
                                onChange={(e) => {
                                  HandleChanges(e);
                                  setRetentionBonusError("");
                                }}
                              />
                              <p className="Error"> {retentionBonusError} </p>
                            </div>
                            <div className="col-sm-3 mt-3 ">
                              <label
                                for="validationCustom01"
                                class="form-label col-6"
                              >
                                Gratuity
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>

                              <input
                                class="form-check-input col-2 JobInfoFields"
                                type="checkbox"
                                checked={data?.is_gratuity}
                                onChange={(e) => {
                                  setData({
                                    ...data,

                                    is_gratuity: e.target.checked,
                                  });
                                }}
                                readOnly={
                                  state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 0 &&
                                    state.ClientBranchIDs.SUBROLE != 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        true
                                        ? false
                                        : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                          false
                                          ? true
                                          : state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                            ? false
                                            : state.NumberCounts.Editable == 2
                                              ? false
                                              : true
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE != 0 &&
                                    state.ClientBranchIDs.SUBROLE != 1 &&
                                    state.ClientBranchIDs.SUBROLE != 3
                                    ? true
                                    : state.NumberCounts.Editable == 1 &&
                                      state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        true
                                        ? false
                                        : state.ClientBranchIDs.SUBROLE == 0 &&
                                          state.NumberCounts.EmployeeFormFIll ==
                                          false
                                          ? true
                                          : state.NumberCounts.EmployeeFormFIll ==
                                            true &&
                                            state.ClientBranchIDs.SUBROLE == 1
                                            ? false
                                            : state.NumberCounts.Editable == 2
                                              ? false
                                              : true
                                }
                              />
                            </div>
                            {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              LWF Employee
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="lwf_employee"
                              value={data?.lwf_employee}
                              onChange={(e) => {
                                HandleChanges(e);
                                setLwfError("");
                              }}
                            />
                            <p className="Error"> {lwfError} </p>
                          </div> */}
                          </>
                        )}
                      {organization?.organization?.id ==
                        "28e108e0-a644-4365-89df-317867f00f22" &&
                        <>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Product Code
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="product_code"
                              value={data?.product_code}
                              disabled
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                            {/* <p className="Error"> {clientNameEr} </p> */}
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Division Level
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              className="Selects"
                              placeholder="Select..."
                              isClearable
                              options={divisionLevelOptions}
                              isDisabled={!canEditDivisionLevel}
                              // single select, but still stored as a one-item list for the payload
                              value={
                                toDivisionLevelList(data?.division_level).map(
                                  (level) => ({ value: level, label: level }),
                                )[0] || null
                              }
                              onChange={(selected) => {
                                setData({
                                  ...data,
                                  division_level: selected
                                    ? [selected.value]
                                    : [],
                                });
                                setDivisionLevelError("");
                              }}
                            />
                            <p className="Error"> {divisionLevelError} </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Joining Bonus
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="joining_bonus"
                              value={data?.joining_bonus}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Entertainment Reimbursement
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="entertainment_reimbursement"
                              value={data?.entertainment_reimbursement}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Stipend
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="Stipend"
                              value={data?.Stipend}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Advance Bonus
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="advance_bonus"
                              value={data?.advance_bonus}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Mobile Expenses
                              {organization?.organization?.id !==
                                "28e108e0-a644-4365-89df-317867f00f22" &&
                                <span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="mobile_expenses"
                              value={data?.mobile_expenses}
                              onChange={(e) => {
                                HandleChanges(e);
                                setMobileExpensesError("");
                              }}
                            />
                            <p className="Error"> {mobileExpensesError} </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Conveyance Reimbursement
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="conveyance"
                              value={data?.conveyance}
                              onChange={(e) => {
                                HandleChanges(e);
                                setConveyanceError("");
                              }}
                            />
                            <p className="Error"> {conveyanceError} </p>
                          </div>

                          <div className="col-sm-3 mt-3 ">
                            <label
                              for="validationCustom01"
                              class="form-label col-6"
                            >
                              Gratuity
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>

                            <input
                              class="form-check-input col-2 JobInfoFields"
                              type="checkbox"
                              checked={data?.is_gratuity}
                              onChange={(e) => {
                                setData({
                                  ...data,

                                  is_gratuity: e.target.checked,
                                });
                              }}



                            />
                          </div>

                        </>}
                      {organization?.organization?.id !=
                        "28e108e0-a644-4365-89df-317867f00f22" && <>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              DA Salary
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="da_salary"
                              value={data?.da_salary}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              CA Salary
                              {organization?.organization?.id ==
                                "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="ca_salary"
                              value={data?.ca_salary}
                              onChange={(e) => {
                                HandleChanges(e);
                                setCAError("");
                              }}
                            />
                            <p className="Error"> {caError} </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              SWA Salary{" "}
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="swa_salary"
                              value={data?.swa_salary}
                              onChange={(e) => {
                                HandleChanges(e);
                                // setClientNaaErr("");
                              }}
                            />
                          </div>
                        </>
                      }

                      {state.NumberCounts.BranchObjectJobInfoFieldAgent &&
                        (state.NumberCounts.BranchObjectJobInfoFieldAgent?.label
                          ?.toLowerCase()
                          .includes("sony india") ||
                          siteObjectVal?.label
                            ?.toLowerCase()
                            .includes("avon")) &&
                        organization?.organization?.id !==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <>
                            <div className="col-sm-3 mt-3">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                Job Status{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                className="Selects stateNames"
                                styles={{ position: "relative", top: "60px" }}
                                menuPlacement="bottom"
                                name="roleSearch"
                                options={
                                  siteObjectVal?.label
                                    ?.toLowerCase()
                                    .includes("avon")
                                    ? [
                                      {
                                        label: "Permanent - Billable",
                                        value: "0",
                                      },
                                      {
                                        label: "Temporary non-billable",
                                        value: "1",
                                      },
                                    ]
                                    : [
                                      { label: "Permanent", value: "0" },
                                      { label: "Temporary", value: "1" },
                                    ]
                                }
                                value={
                                  jobinfo?.job_status
                                    ? {
                                      label: siteObjectVal?.label
                                        ?.toLowerCase()
                                        .includes("avon")
                                        ? jobinfo.job_status === "0"
                                          ? "Permanent - Billable "
                                          : "Temporary non-billable"
                                        : jobinfo.job_status === "0"
                                          ? "Permanent"
                                          : "Temporary",
                                      value: jobinfo.job_status,
                                    }
                                    : null
                                }
                                isDisabled={
                                  state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.NumberCounts.EmployeeFormFIll ==
                                    false && true
                                }
                                onChange={(e) => {
                                  setjobinfo((prev) => ({
                                    ...prev,
                                    job_status: e.value,
                                    end_date:
                                      e.value == 0 ? "" : jobinfo?.end_date,
                                  }));
                                }}
                                labelledBy="Select"
                              />
                            </div>

                            {jobinfo?.job_status === "1" && (
                              <div className="col-sm-3 mt-3">
                                <label
                                  htmlFor="validationCustom01"
                                  className="form-label"
                                >
                                  End Date{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="validationCustom01"
                                  autoComplete="off"
                                  name="end_date"
                                  // min={new Date().toISOString().split("T")[0]} // ✅ Prevent past dates
                                  value={jobinfo?.end_date}
                                  min={
                                    new Date(
                                      new Date().setMonth(
                                        new Date().getMonth() - 2,
                                      ),
                                    )
                                      .toISOString()
                                      .split("T")[0]
                                  } // ✅ Allow up to 2 months in the past
                                  max={
                                    new Date(
                                      new Date().setMonth(
                                        new Date().getMonth() + 2,
                                      ),
                                    )
                                      .toISOString()
                                      .split("T")[0]
                                  } // ✅ Allow only up to 2 months in future
                                  onChange={(e) => {
                                    setjobinfo((prev) => ({
                                      ...prev,
                                      end_date: e.target.value,
                                    }));
                                    setend_daterr("");
                                  }}
                                  onKeyDown={preventTyping}
                                  onFocus={(e) => e.target.showPicker()}
                                  disabled={
                                    state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.NumberCounts.EmployeeFormFIll ==
                                      false && true
                                  }
                                  readOnly={
                                    state.ClientBranchIDs.SUBROLE == 3
                                      ? false
                                      : state.NumberCounts.EmployeeFormFIll ==
                                      false && true
                                  }
                                />

                                <p
                                  className="Error"
                                  style={{ marginLeft: "-5px" }}
                                >
                                  {end_dateerr}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      {organization?.organization?.id ==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <>
                            <div className="col-sm-3 mt-3">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                Project Nature{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                className="Selects stateNames"
                                styles={{ position: "relative", top: "60px" }}
                                menuPlacement="bottom"
                                name="project_nature"
                                options={[
                                  {
                                    label: "Managed",
                                    value: "0",
                                  },
                                  {
                                    label: "Non Managed",
                                    value: "1",
                                  },
                                ]}
                                value={
                                  jobinfo?.project_nature == "0"
                                    ? { label: "Managed", value: "0" }
                                    : jobinfo?.project_nature == "1"
                                      ? { label: "Non Managed", value: "1" }
                                      : ""
                                }
                                isDisabled={
                                  state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.NumberCounts.EmployeeFormFIll ==
                                    false && true
                                }
                                onChange={(e) => {
                                  setjobinfo((prev) => ({
                                    ...prev,
                                    project_nature: e.value,
                                  }));
                                  setProjectNatureError("");
                                }}
                                labelledBy="Select"
                              />
                              <p className="Error"> {projectNatureError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                Billing ability{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                className="Selects stateNames"
                                styles={{ position: "relative", top: "60px" }}
                                menuPlacement="bottom"
                                name="billabilty"
                                options={[
                                  {
                                    label: "Billable",
                                    value: "0",
                                  },
                                  {
                                    label: "Non Billable",
                                    value: "1",
                                  },
                                ]}
                                value={
                                  jobinfo?.billabilty == "0"
                                    ? { label: "Billable", value: "0" }
                                    : jobinfo?.billabilty == "1"
                                      ? { label: "Non Billable", value: "1" }
                                      : ""
                                }
                                isDisabled={
                                  state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.NumberCounts.EmployeeFormFIll ==
                                    false && true
                                }
                                onChange={(e) => {
                                  setjobinfo((prev) => ({
                                    ...prev,
                                    billabilty: e.value,
                                  }));
                                  setBillingAbilityError("");
                                }}
                                labelledBy="Select"
                              />
                              <p className="Error"> {billingAbilityError} </p>
                            </div>
                            <div className="col-sm-3 mt-3">
                              <label
                                htmlFor="validationCustom01"
                                className="form-label"
                              >
                                Billing Type{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                className="Selects stateNames"
                                styles={{ position: "relative", top: "60px" }}
                                menuPlacement="bottom"
                                name="billing_type"
                                options={
                                  jobinfo?.billabilty == "0"
                                    ? [
                                      {
                                        label: "Fixed",
                                        value: "0",
                                      },
                                      {
                                        label: "Actual",
                                        value: "1",
                                      },
                                    ]
                                    : jobinfo?.billabilty == "1"
                                      ? [
                                        {
                                          label: "Non Billable",
                                          value: "2",
                                        },
                                      ]
                                      : [
                                        {
                                          label: "Fixed",
                                          value: "0",
                                        },
                                        {
                                          label: "Actual",
                                          value: "1",
                                        },
                                        {
                                          label: "Non Billable",
                                          value: "2",
                                        },
                                      ]
                                }
                                value={
                                  jobinfo?.billing_type == "0"
                                    ? { label: "Fixed", value: "0" }
                                    : jobinfo?.billing_type == "1"
                                      ? { label: "Actual", value: "1" }
                                      : jobinfo?.billing_type == "2"
                                        ? { label: "Non Billable", value: "2" }
                                        : ""
                                }
                                isDisabled={
                                  state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.NumberCounts.EmployeeFormFIll ==
                                    false && true
                                }
                                onChange={(e) => {
                                  setjobinfo((prev) => ({
                                    ...prev,
                                    billing_type: e.value,
                                  }));
                                  setBillingTypeError("");
                                }}
                                labelledBy="Select"
                              />
                              <p className="Error"> {billingTypeError} </p>
                            </div>
                          </>
                        )}

                      <div className="col-sm-3 mt-3 ">
                        <label
                          for="validationCustom01"
                          class="form-label col-6"
                        >
                          Add Basic Salary
                        </label>

                        <input
                          class="form-check-input col-2 JobInfoFields"
                          type="checkbox"
                          checked={addbasic}
                          onChange={(e) => {
                            setthebasic(!addbasic);
                            setData({
                              ...data,
                              other_allowances_salary: "",
                              net_salary: "",
                              hra_salary: "",
                              employee_PF: "",
                              employee_ESI: "",
                              basic_salary: "",
                              airtime_allowance: "",
                            });
                            setErrInde(0);
                          }}
                          readOnly={
                            state.NumberCounts.Editable == 1 &&
                              state.ClientBranchIDs.SUBROLE != 0 &&
                              state.ClientBranchIDs.SUBROLE != 1 &&
                              state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE == 3
                                ? false
                                : state.ClientBranchIDs.SUBROLE == 0 &&
                                  state.NumberCounts.EmployeeFormFIll == true
                                  ? false
                                  : state.ClientBranchIDs.SUBROLE == 0 &&
                                    state.NumberCounts.EmployeeFormFIll ==
                                    false
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                      true &&
                                      state.ClientBranchIDs.SUBROLE == 1
                                      ? false
                                      : state.NumberCounts.Editable == 2
                                        ? false
                                        : true
                          }
                          disabled={
                            state.NumberCounts.Editable == 1 &&
                              state.ClientBranchIDs.SUBROLE != 0 &&
                              state.ClientBranchIDs.SUBROLE != 1 &&
                              state.ClientBranchIDs.SUBROLE != 3
                              ? true
                              : state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE == 3
                                ? false
                                : state.ClientBranchIDs.SUBROLE == 0 &&
                                  state.NumberCounts.EmployeeFormFIll == true
                                  ? false
                                  : state.ClientBranchIDs.SUBROLE == 0 &&
                                    state.NumberCounts.EmployeeFormFIll ==
                                    false
                                    ? true
                                    : state.NumberCounts.EmployeeFormFIll ==
                                      true &&
                                      state.ClientBranchIDs.SUBROLE == 1
                                      ? false
                                      : state.NumberCounts.Editable == 2
                                        ? false
                                        : true
                          }
                        />
                      </div>

                      {addbasic == true ? (
                        <>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Basic Salary
                              {organization?.organization?.id ==
                                "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setBasicErr(
                                    "*Basic Salary cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);
                                  // Revert to previous valid value
                                  // setData({
                                  //   ...data,
                                  //   basic_salary: data.basic_salary // keep the previous value
                                  // });
                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (
                                  parsedValue <= 0 &&
                                  organization?.organization?.id !==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
                                ) {
                                  setBasicErr(
                                    "*Basic Salary must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    basic_salary: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setBasicErr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  basic_salary: value,
                                });
                              }}
                              autocomplete="off"
                              name="basic_salary"
                              value={data.basic_salary}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {basicErro}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              HRA
                              {organization?.organization?.id ==
                                "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setHraErr(
                                    "*HRA Salary cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);
                                  // Revert to previous valid value
                                  // setData({
                                  //   ...data,
                                  //   basic_salary: data.basic_salary // keep the previous value
                                  // });
                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (
                                  parsedValue <= 0 &&
                                  organization?.organization?.id !==
                                  "11a8ab83-0669-4098-a453-ddb2a2e0c39e"
                                ) {
                                  setHraErr(
                                    "*HRA Salary must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    hra_salary: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setHraErr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  hra_salary: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="hra_salary"
                              value={data.hra_salary}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {hraerr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Other Allowances
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setOtherErr(
                                    "*Other Allowances  cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);
                                  // Revert to previous valid value
                                  // setData({
                                  //   ...data,
                                  //   basic_salary: data.basic_salary // keep the previous value
                                  // });
                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setOtherErr(
                                    "*Other Allowances  must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    other_allowances_salary: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setOtherErr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  other_allowances_salary: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="other_allowances_salary"
                              value={data.other_allowances_salary}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {otherErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Employee ESI
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;
                                console.log(values, "093-0912093values");

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setESIerr("*ESI cannot exceed 8 digits.");
                                  setErrInde(1);

                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setESIerr("*ESI must be greater than 0.");
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    employee_ESI: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setESIerr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  employee_ESI: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="employee_ESI"
                              value={data.employee_ESI}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {ESIErr}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Employee PF
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 9) {
                                  setPFerr("*PF cannot exceed 8 digits.");
                                  setErrInde(1);

                                  return;
                                }
                                console.log(value.length, "value.length234");

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setPFerr("*PF must be greater than 0.");
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    employee_PF: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setPFerr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  employee_PF: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="employee_PF"
                              value={data.employee_PF}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {pferr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Airtime Allowance
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setAirTimeAllo(
                                    "*Airtime Allowance cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);

                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setAirTimeAllo(
                                    "*Airtime Allowance must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    airtime_allowance: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setAirTimeAllo("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  airtime_allowance: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="airtime_allowance"
                              value={data.airtime_allowance}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {AirTimeErr}
                            </p>
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Net Salary
                            </label>

                            <NumericFormat
                              thousandSeparator={true}
                              onValueChange={(values) => {
                                const { value } = values;

                                // Parse the value as a number
                                const parsedValue = parseFloat(value);

                                // Check if input exceeds 8 digits
                                if (value.length > 8) {
                                  setNetSalarErr(
                                    "*Net Salary cannot exceed 8 digits.",
                                  );
                                  setErrInde(1);

                                  return;
                                }

                                // Check if input is less than or equal to 0
                                if (parsedValue <= 0) {
                                  setNetSalarErr(
                                    "*Net Salary must be greater than 0.",
                                  );
                                  setErrInde(1);
                                  // Clear the field
                                  setData({
                                    ...data,
                                    net_salary: "",
                                  });
                                  return;
                                }

                                // Valid input
                                setNetSalarErr("");
                                setErrInde(0);
                                setData({
                                  ...data,
                                  net_salary: value,
                                });
                              }}
                              // ref={inputRef}
                              autocomplete="off"
                              name="net_salary"
                              value={data.net_salary}
                              isNumericString
                              displayType={"input"}
                              fixedDecimalScale={true}
                              className="form-control FormalFiledReport"
                              //  style={{height:"45%"}}

                              // onChange={handleChange}
                              // onInput={handleChange}
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 0 &&
                                  state.ClientBranchIDs.SUBROLE != 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : state.NumberCounts.Editable == 1 &&
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 0 &&
                                      state.NumberCounts.EmployeeFormFIll ==
                                      true
                                      ? false
                                      : state.ClientBranchIDs.SUBROLE == 0 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                        false
                                        ? true
                                        : state.NumberCounts.EmployeeFormFIll ==
                                          true &&
                                          state.ClientBranchIDs.SUBROLE == 1
                                          ? false
                                          : state.NumberCounts.Editable == 2
                                            ? false
                                            : true
                              }
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {netslaraer}
                            </p>
                          </div>
                        </>
                      ) : null}
                    </div>

                    <div className="row">
                      {/* <div className="col mt-3">
                        <label for="validationCustom01" class="form-label">
                          Designation
                        </label>
                        {state.NumberCounts.Editable == 1 ? (
                          ""
                        ) : (
                          <span style={{ color: "red" }}>*</span>
                        )}

                        <input
                          type="text"
                          class="form-control"
                          id="validationCustom01"
                          autocomplete="off"
                          name="designation"
                          readOnly={
                            state.NumberCounts.Editable == 1 ? true : false
                          }
                          onChange={(e) => {
                            HandleChanges(e);
                            setdesginationErr("");
                          }}
                          value={data.designation}
                        />
                        <p className="Error" style={{ marginLeft: "-5px" }}>
                          {designationerr}
                        </p>
                      </div> */}
                    </div>
                  </div>
                  <div
                    className="bottomButton"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "15px",
                      paddingLeft: "15px",
                    }}
                  >
                    { }
                    <div className="RoleButton">
                      {organization?.organization?.id ==
                        "11a8ab83-0669-4098-a453-ddb2a2e0c39e" && (
                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#EF4D39" }}
                            onClick={(e) => {
                              HandlePreview();
                            }}
                          >
                            Salary Preview
                          </button>
                        )}
                    </div>

                    {
                      // state.NumberCounts.EmployeeFormFIll == true &&

                      // (

                      //                SubRoleList == 0 ||
                      //   SubRoleList == 1 ||
                      //   state.ClientBranchIDs.SUBROLE == 3 )

                      //                   ||state.NumberCounts.Editable == 2

                      state.ClientBranchIDs.SUBROLE == 3 ? (
                        // ||
                        // state.NumberCounts.Editable == 2 ||
                        // (state.ClientBranchIDs.SUBROLE == 0 || state.ClientBranchIDs.SUBROLE == 1 && state.NumberCounts.EmployeeFormFIll == true)

                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "0px 15px",

                            marginBottom: "20px",
                          }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#F26239" }}
                            onClick={(e) => {
                              HandlePrevious(e);
                            }}
                          >
                            Previous
                          </button>

                          <button
                            class="btn ButtonCSS"
                            style={{ color: "#ffff", background: "#EF4D39" }}
                            onClick={(e) => {
                              HandleNext(e);
                            }}
                          >
                            Save & Continue
                          </button>
                        </div>
                      ) : (
                        <>
                          {state.NumberCounts.EmployeeFormFIll != false &&
                            (state.NumberCounts.Editable == 2 ||
                              state.ClientBranchIDs.SUBROLE == 0 ||
                              state.ClientBranchIDs.SUBROLE == 1) ? (
                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                padding: "0px 15px",

                                marginBottom: "20px",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#F26239",
                                }}
                                onClick={(e) => {
                                  HandlePrevious(e);
                                }}
                              >
                                Previous
                              </button>

                              <button
                                class="btn ButtonCSS"
                                style={{
                                  color: "#ffff",
                                  background: "#EF4D39",
                                }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                          ) : null}
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          {salaryPreviewPopup && (
            <SalaryOfferPreviewPopup
              data={state?.JOBOfferPreviewCall?.JobOfferPreivewData}
              onClose={() => setSalaryPreviewPopup(false)}
              show={salaryPreviewPopup}
            />
          )}
          {console.log(data, "dlkasskldaskdklas")}
        </div>
      </div>
    </div>
  );
};

export default Joboffer;
